/*
 * Trigger Button class
 */
class TriggerButton {
  /**
   * @private
   * @property {HTMLElement} #element - HTMLElement of the trigger button
   */
  #element

  /**
   * @private
   * @property {HTMLElement} #target - HTMLElement of the trigger target
   */
  #target

  /**
   * @private
   * @property {String} #trigger - Event to trigger the target
   */
  #trigger

  /**
  * @constructor
  * @param {HTMLElement} element element to bind to
  */
  constructor(element) {
    this.#element = element;

    this.#target = document.querySelector(this.#element.dataset.target);
    this.#trigger = this.#element.dataset.trigger;

    if (this.#target && this.#trigger) {
      this.#element.addEventListener('click', this.#onTriggerButtonClicked.bind(this));
    }
  }

  #onTriggerButtonClicked(event) {
    event.preventDefault();

    if (this.#trigger === 'click') {
      this.#target.click();
    } else if (this.#trigger === 'submit') {
      this.#target.submit();
    } else {
      this.#target.dispatchEvent(new Event(this.#trigger));
    }
  }

  /**
   * Called to initialize collapse areas and handles
   */
  static init() {
    document.querySelectorAll('.js-trigger-button[data-target][data-trigger]').forEach(element => new TriggerButton(element));
  }
}

export default TriggerButton;
